const formatDateRange = (
  startedAt?: string,
  endedAt?: string
): string | undefined => {
  try {
    if (!startedAt) return undefined;
    const start = new Date(startedAt);

    if (!endedAt) {
      return start.toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    }
    const end = new Date(endedAt);
    const sameMonth =
      start.getFullYear() === end.getFullYear() &&
      start.getMonth() === end.getMonth();

    if (sameMonth) {
      const monthYear = start.toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
      });

      return `${start.getDate()}-${end.getDate()}, ${monthYear}`;
    }
    const startStr = start.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
    const endStr = end.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

    return `${startStr} - ${endStr}`;
  } catch (error) {
    return undefined;
  }
};

export const SignatureProfileEvents = ({ profile }: { profile: any }) => {
  const events = Array.isArray(profile?.upcomingEvents)
    ? profile.upcomingEvents
    : [];

  if (events.length === 0) return null;

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div>
          {/* 27. Signature profile upcoming events */}
          <h2 className="font-playfair text-3xl font-bold mb-8">
            Upcoming Events
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {events.map((event: any) => {
              const dateRange = formatDateRange(
                event?.startedAt,
                event?.endedAt
              );
              const hasImage = Boolean(event?.pictureLargeUrl);
              const hasLink = Boolean(event?.link);

              return (
                <div
                  key={event?.id || `${event?.title}-${event?.startedAt}`}
                  className="bg-gray-50 rounded-lg overflow-hidden shadow-sm transition-all hover:shadow-md"
                >
                  {hasImage ? (
                    <img
                      src={event.pictureLargeUrl}
                      alt={event?.title || "Event image"}
                      className="w-full h-48 object-cover"
                    />
                  ) : null}
                  <div className="p-5">
                    {event?.title ? (
                      <h3 className="font-playfair font-bold text-xl mb-2">
                        {event.title}
                      </h3>
                    ) : null}
                    {dateRange ? (
                      <p className="text-artist-accent font-medium mb-1">
                        {dateRange}
                      </p>
                    ) : null}
                    {event?.location ? (
                      <p className="text-muted-foreground">{event.location}</p>
                    ) : null}
                    {hasLink ? (
                      <a
                        href={event.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 underline-offset-4 hover:underline p-0 h-auto mt-2 text-artist-accent"
                      >
                        Learn more
                      </a>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SignatureProfileEvents;
